/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ minutes: NonNullable<unknown> }} Auth_Session_Expiring_Soon_MinutesInputs */



/**
* | output |
* | --- |
* | "Your session ends in {minutes} min. Sign in again to keep working." |
*
* @param {Auth_Session_Expiring_Soon_MinutesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_session_expiring_soon_minutes = /** @type {((inputs: Auth_Session_Expiring_Soon_MinutesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Session_Expiring_Soon_MinutesInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Deine Sitzung endet in ${i?.minutes} Min. Melde dich erneut an, um weiterzuarbeiten.`)
	return /** @type {LocalizedString} */ (`Your session ends in ${i?.minutes} min. Sign in again to keep working.`)
});